export const isElementInViewport = (el?: HTMLElement): boolean => {
    if (!el) {
        return false;
    }

    const boundaries = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    // make sure in case the element it's being inside an element it's and cut off by the parent
    // we make sure it's fully visible
    let isVisibleInElement = true;
    const parent = el.parentElement;
    if (parent) {
        isVisibleInElement =
            boundaries.top >= parent.offsetTop &&
            boundaries.left >= parent.offsetLeft &&
            boundaries.bottom <= parent.offsetTop + parent.clientHeight &&
            boundaries.right <= parent.offsetLeft + parent.clientWidth;
    }

    return (
        isVisibleInElement &&
        boundaries.top >= 0 &&
        boundaries.left >= 0 &&
        boundaries.bottom <= viewportHeight &&
        boundaries.right <= viewportWidth
    );
};
